import { render } from "./price.vue?vue&type=template&id=606c3f56"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/price.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "606c3f56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('606c3f56', __exports__)) {
    console.log('reload')
    api.reload('606c3f56', __exports__)
  }
  
  module.hot.accept("./price.vue?vue&type=template&id=606c3f56", () => {
    console.log('re-render')
    api.rerender('606c3f56', render)
  })

}


export default __exports__